import { Breadcrumb } from "client/Components";
import { Folderish } from "client_legacy/Documents/SharePoint/models";
import { ReactElement, useCallback } from "react";
import { FolderNavigationStackItem } from "./useFolderNavigationStack";

export type SharePointBreadCrumbProps = {
	items: readonly FolderNavigationStackItem[];
	onOpenFolder: (folder: Folderish) => void;
};

export const SharePointBreadCrumb = (props: SharePointBreadCrumbProps): ReactElement => {
	const {
		items,
		onOpenFolder
	} = props;

	const onNavigateHandler = useCallback(
		(item: FolderNavigationStackItem): void => {
			onOpenFolder(item.folder);
		},
		[onOpenFolder]
	);

	return (
		<Breadcrumb
			segments={items}
			onNavigate={onNavigateHandler}
			trackingId="sharepoint-bread-crumb"
			getSegmentTrackingId={getSegmentTrackingId}
		/>
	);
};
SharePointBreadCrumb.displayName = "SharePointBreadCrumb";

function getSegmentTrackingId(item: FolderNavigationStackItem): string {
	const { folder } = item;
	if (!folder) {
		return "placeholder";
	}
	if (folder.isRoot) {
		return "root";
	} else {
		return `${folder.id}`;
	}
}
